"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmartFolderQuote = SmartFolderQuote;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactI18next = require("react-i18next");

var Container = function Container(_ref) {
  var children = _ref.children,
      _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full h-full flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8 pr-24",
    style: {
      maxWidth: 800,
      borderRadius: '100%',
      background: invert ? 'radial-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.1) 40%, rgba(0,0,0,0) 70%)' : ''
    }
  }, children));
};

var Quote = function Quote(_ref2) {
  var author = _ref2.author,
      content = _ref2.content,
      _ref2$invert = _ref2.invert,
      invert = _ref2$invert === void 0 ? false : _ref2$invert;
  return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('text-center', invert ? 'text-white' : 'text-dark')
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "mb-3 text-xl font-semibold truncate-3"
  }, content), author && /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-semibold uppercase mt-6 text-sm"
  }, author)));
};

var _default = Quote;
exports["default"] = _default;

function SmartFolderQuote(_ref3) {
  var folder = _ref3.folder,
      _ref3$invert = _ref3.invert,
      invert = _ref3$invert === void 0 ? false : _ref3$invert;
  return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('text-center text-xl', invert ? 'text-white' : 'text-dark')
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "inboxZero.".concat(folder, ".quote")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-4 font-semibold"
  }))));
}
//# sourceMappingURL=InboxQuote.js.map